export default {"src":"/_next/static/media/phone_white_outline_64.5d4992a6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};